export const HelpCenterTranslations = {
    newTicket: 'helpCenter.newTicket',
    next: 'helpCenter.newTicket.next',
    cancel: 'helpCenter.newTicket.cancel',
    previous: 'helpCenter.newTicket.previous',
    submit: 'helpCenter.newTicket.submit',
    navigation: {
        back: 'helpCenter.navigation.back'
    },
    step1: {
        title: 'helpCenter.step1.title',
        subtitle: 'helpCenter.step1.subtitle'
    },
    step2: {
        title: 'helpCenter.step2.title',
        subtitle: 'helpCenter.step2.subtitle'
    },
    step3: {
        title: 'helpCenter.step3.title',
        subtitle: 'helpCenter.step3.subtitle',
        noSpecificProduct: 'helpCenter.form.reason.no_specific_product',
    },
    step4: {
        title: 'helpCenter.step4.title',
        subtitle: 'helpCenter.step4.subtitle',
        subject: {
            label: 'helpCenter.step4.subject.label',
            placeholder: 'helpCenter.step4.subject.placeholder',
            legend: 'helpCenter.step4.subject.legend',
            maxChars: 'helpCenter.step4.subject.maxChars'
        },
        description: {
            label: 'helpCenter.step4.description.label',
            placeholder: 'helpCenter.step4.description.placeholder',
            legend: 'helpCenter.step4.description.legend',
            maxChars: 'helpCenter.step4.description.maxChars'
        },
        caseFiles: {
            label: 'helpCenter.step4.caseFiles.label',
        },
        contactData: {
            title: 'helpCenter.step4.contactData.title',
            description: 'helpCenter.step4.contactData.description',
            email: 'helpCenter.step4.contactData.email',
            phone: 'helpCenter.step4.contactData.phone',
            infoMessage: 'helpCenter.step4.contactData.infoMessage',
            changeAccessMode: 'helpCenter.step4.contactData.changeAccessMode',
            alternativeContact: 'helpCenter.step4.contactData.alternativeContact',
            alternativeEmail: 'helpCenter.step4.contactData.alternativeEmail',
            alternativeEmailPlaceholder: 'helpCenter.step4.contactData.alternativeEmail.placeholder',
            alternativePhone: 'helpCenter.step4.contactData.alternativePhone',
            alternativePhonePlaceholder: 'helpCenter.step4.contactData.alternativePhone.placeholder',
            alternativePhoneLegend: 'helpCenter.step4.contactData.alternativePhone.legend'
        },
        privacyPolicy: {
            label: 'helpCenter.step4.privacyPolicy.label',
            link: 'helpCenter.step4.privacyPolicy.link'
        },
        form: {
            invalidFormat: 'helpCenter.form.error.invalid_format',
            acceptPrivacyPolicy: 'helpCenter.form.error.accept_privacy_policy',
            invalidFileType: 'helpCenter.form.error.invalid_file_type',
            maxFileSize: 'helpCenter.form.error.max_file_size'
        }
    },
    successMessage: 'helpCenter.successMessage',
    cancelModal: {
        title: 'helpCenter.cancelModal.title',
        description: 'helpCenter.cancelModal.description',
        cancelButton: 'helpCenter.cancelModal.cancelButton',
        exitButton: 'helpCenter.cancelModal.exitButton'
    }  
}